// extracted by css-extract-rspack-plugin
export default {"backdrop":"ConfirmationModal-backdrop_zYJ","modal":"ConfirmationModal-modal_j1x"};